import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=45e8cbdb&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
import style0 from "./Tab.css?vue&type=style&index=0&id=45e8cbdb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8cbdb",
  null
  
)

export default component.exports